export const environment = {
  production: false,
  appInsights: {
    instrumentationKey: ''
  }
};
